#import "../fragments/usage-scorecard-entry-fragment.graphql"

query GetUsageScorecard {
    usageScorecard {
        sections {
            sectionName
            features {
                ...UsageScorecardEntry
            }
        }
    }
}
